"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toTextWithContentSlice = exports.toAnchoredSlice = exports.toSlice = void 0;
var utils_1 = require("@lglp/utils");
var fields_1 = require("../fields");
var toSlice = function (data, type) {
    var _a;
    return utils_1.compact({
        type: type,
        enabled: fields_1.toBoolean((_a = data.primary) === null || _a === void 0 ? void 0 : _a.enabled, { defaultValue: true })
    });
};
exports.toSlice = toSlice;
var toAnchoredSlice = function (data, type) {
    var _a;
    return utils_1.compact(__assign(__assign({}, exports.toSlice(data, type)), { anchorName: fields_1.toAnchor((_a = data === null || data === void 0 ? void 0 : data.primary) === null || _a === void 0 ? void 0 : _a.anchorName) }));
};
exports.toAnchoredSlice = toAnchoredSlice;
var toTextWithContentSlice = function (data, type, logger) {
    var _a, _b;
    return utils_1.compact(__assign(__assign({}, exports.toSlice(data, type)), { text: logger.required(fields_1.toRichText((_a = data === null || data === void 0 ? void 0 : data.primary) === null || _a === void 0 ? void 0 : _a.text, logger)), textPosition: logger.required(logger.toConstValue((_b = data === null || data === void 0 ? void 0 : data.primary) === null || _b === void 0 ? void 0 : _b.textPosition, {
            Gauche: 'left',
            Droite: 'right'
        })) }));
};
exports.toTextWithContentSlice = toTextWithContentSlice;
//# sourceMappingURL=slice.js.map